// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1132":"bc7b8204","3175":"bc7b8204","4272":"bc7b8204","5275":"bc7b8204","8717":"bc7b8204","9300":"bc7b8204"}[chunkId] + ".chunk.css";
};